module.exports = __webpack_public_path__ + "img/131w.03838d1.jpg";